module.exports = __webpack_public_path__ + "img/coins-submit-bg.d7e62679.png";